import request from 'superagent'

class OSM {
  constructor () {
    this.root = 'https://nominatim.openstreetmap.org'

    this.forwardUrl = `${this.root}/search`
    this.reverseUrl = `${this.root}/reverse`
  }

  getFromQuery (search) {
    const query = `/${search}?addressdetails=1&extratags=1&namedetails=1&format=jsonv2` 

    return request
      .get(`${this.forwardUrl}${query}`)
      .then(({ body }) => body)
  }

  getFromCenter ({ lat, long }) {
    const query = `?lon=${long}&lat=${lat}&addressdetails=1&extratags=1&namedetails=1&format=jsonv2` 

    return request
      .get(`${this.reverseUrl}${query}`)
      .then(({ body }) => body)
  }
}

export default new OSM()